export class CognitoAuthError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CognitoAuthError';
  }
}

export class ConfigFetchError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ConfigFetchError';
  }
}

export class ConfigParseError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ConfigParseError';
  }
}
